import { render, staticRenderFns } from "./SettingsLegacy.vue?vue&type=template&id=76e7d1a5&scoped=true"
import script from "./SettingsLegacy.vue?vue&type=script&lang=js"
export * from "./SettingsLegacy.vue?vue&type=script&lang=js"
import style0 from "./SettingsLegacy.vue?vue&type=style&index=0&id=76e7d1a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e7d1a5",
  null
  
)

export default component.exports